import React, { useState, useEffect } from 'react';
import './CustomToast.css';

export default function CustomToast({ message, type = 'info', onClose }) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setExiting(true);
      setTimeout(onClose, 400); // match fadeOut duration
    }, 3000); // auto-dismiss after 3s

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`custom-toast ${type} ${exiting ? 'exit' : ''}`}>
      <span>{message}</span>
      <button
        onClick={() => {
          setExiting(true);
          setTimeout(onClose, 400);
        }}
        className="close-btn"
      >
        ×
      </button>
    </div>
  );
}
